// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const I18nProvider = registerClientReference(
    function() { throw new Error("Attempted to call I18nProvider() from the server but I18nProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/i18n/index.tsx",
    "I18nProvider",
);
export const LOCALES = registerClientReference(
    function() { throw new Error("Attempted to call LOCALES() from the server but LOCALES is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/i18n/index.tsx",
    "LOCALES",
);
export const LOCALE_LABEL = registerClientReference(
    function() { throw new Error("Attempted to call LOCALE_LABEL() from the server but LOCALE_LABEL is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/i18n/index.tsx",
    "LOCALE_LABEL",
);
export const useI18n = registerClientReference(
    function() { throw new Error("Attempted to call useI18n() from the server but useI18n is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/i18n/index.tsx",
    "useI18n",
);
export const useT = registerClientReference(
    function() { throw new Error("Attempted to call useT() from the server but useT is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/i18n/index.tsx",
    "useT",
);
